/*!
 * @license
 * Alfresco Example Content Application
 *
 * Copyright (C) 2005 - 2020 Alfresco Software Limited
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail.  Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with Alfresco. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore, ViewNodeAction } from '@alfresco/aca-shared/store';
import { ActivatedRoute, Params } from '@angular/router';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-view-in-tab',
  template: `
    hello
  `,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-view-in-tab' }
})
export class ViewInTabComponent implements OnInit {

  constructor(private store: Store<AppStore>, public route: ActivatedRoute) {


  }
  ngOnInit(): void {

    this.route.params.pipe(take(1)).subscribe(({ parentId, id }: Params) => {

      //console.log("ngOnInit: nodeId", id);
      //console.log("ticket", ticket);
      this.store.dispatch(new ViewNodeAction(id, {
        "location": "/libraries/" + parentId
    }));

    });
  }


}
